'use strict';
import $ from "jquery";

angular.module('docketbook').
  controller('signatureModalController', function ($rootScope, $scope, $state, $stateParams, accessControl, $timeout, geolocation) {

    $scope.signatureCapture = {};

    $scope.configureSignaturePad = function () {
      var canvas = $("#signatureCapture");
      var context = document.getElementById('signatureCapture').getContext('2d');
      var windowWidth = $(window).width();
      context.canvas.width = windowWidth;
      var offsetLeft;
      var offsetTop;
      var painting = false;
      var lastX = 0;
      var lastY = 0;
      var lineThickness = 0.5;

      canvas.mousedown(function (e) {
        offsetLeft = canvas.offset().left;
        offsetTop = canvas.offset().top;
        painting = true;
        context.fillStyle = "#000000";
        lastX = e.pageX - offsetLeft;
        lastY = e.pageY - offsetTop;
      });

      canvas.bind('touchstart', function (e) {
        offsetLeft = canvas.offset().left;
        offsetTop = canvas.offset().top;
        lastX = e.originalEvent.touches[0].pageX - offsetLeft;
        lastY = e.originalEvent.touches[0].pageY - offsetTop;
        painting = true;
        context.fillStyle = "#000000";
        e.preventDefault();
      });

      canvas.mouseup(function (e) {
        painting = false;
      });

      canvas.bind('touchend', function (e) {
        painting = false;
        e.preventDefault();
      });

      canvas.mouseleave(function (e) {
        painting = false;
      });

      canvas.mousemove(function (e) {
        if (painting) {
          drawPoint(e.pageX - offsetLeft, e.pageY - offsetTop);
        }
      });

      canvas.bind('touchmove', function (e) {
        if (painting) {
          drawPoint(
            e.originalEvent.touches[0].pageX - offsetLeft,
            e.originalEvent.touches[0].pageY - offsetTop
          );
          e.preventDefault();
        }
      });

      function drawPoint(mouseX, mouseY) {
        // find all points between
        var x1 = mouseX,
          x2 = lastX,
          y1 = mouseY,
          y2 = lastY;

        var steep = (Math.abs(y2 - y1) > Math.abs(x2 - x1));

        if (steep) {
          var x = x1;
          x1 = y1;
          y1 = x;

          var y = y2;
          y2 = x2;
          x2 = y;
        }

        if (x1 > x2) {
          var x = x1;
          x1 = x2;
          x2 = x;

          var y = y1;
          y1 = y2;
          y2 = y;
        }

        var dx = x2 - x1,
          dy = Math.abs(y2 - y1),
          error = 0,
          de = dy / dx,
          yStep = -1,
          y = y1;

        if (y1 < y2) {
          yStep = 1;
        }

        lineThickness = 3 - Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1)) / 10;
        if (lineThickness < 1) {
          lineThickness = 1;
        }

        for (var x = x1; x < x2; x++) {
          if (steep) {
            context.fillRect(y, x, lineThickness, lineThickness);
          } else {
            context.fillRect(x, y, lineThickness, lineThickness);
          }

          error += de;
          if (error >= 0.5) {
            y += yStep;
            error -= 1.0;
          }
        }

        lastX = mouseX;
        lastY = mouseY;
      }

      // touch support
      canvas.bind('scroll', function (e) {
        e.preventDefault();
      });
    }

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.captureSignatureFromParent = function (entity, nameRequired, name, terms, template, cb) {
      $scope.signatureCaptureCallback = cb;
      $scope.signatureCapture = {};
      $scope.signatureCapture.entity = entity;
      $scope.signatureCapture.name = name;
      $scope.signatureCapture.attachments = [];
      $scope.signatureCapture.template = template;
      var termsAttachments = [];
      if (template && template.attachments) {
        for (var i = 0; i < template.attachments.length; i++) {
          if (template.attachments[i].type == 'termsConditions') {
            $scope.signatureCapture.attachments.push(template.attachments[i]);
          }
        }
      }
      if (nameRequired != null) {
        $scope.signatureCapture.nameRequired = nameRequired;
      } else {
        $scope.signatureCapture.nameRequired = false;
      }
      if (terms) {
        $scope.signatureCapture.terms = terms;
        $scope.signatureCapture.termsRequired = true;
      } else {
        $scope.signatureCapture.termsRequired = false;
      }
      $scope.configureSignaturePad();
      $("#signatureCaptureModal").fadeIn(100, function () {
        document.getElementById('signatureCapture').width = $("#signatureCaptureModal .modalContainer").outerWidth();
      });
    }

    /*******************************/
    /***** Signature Functions *****/
    /*******************************/

    $scope.closeSignatureCapture = function () {
      $("#signatureCaptureModal").fadeOut(100);
      $scope.signatureCaptureCallback(null);
    }

    function isCanvasBlank(canvas) {
      return !canvas.getContext('2d')
        .getImageData(0, 0, canvas.width, canvas.height).data
        .some(channel => channel !== 0);
    }

    $scope.saveSignatureCapture = function () {
      var canvas = document.getElementById('signatureCapture');
      var image = canvas.toDataURL("image/png");
      var imageToSave = image.split(',')[1];

      if (isCanvasBlank(canvas)) {
        return
      }

      var returnObject = {};
      returnObject.signatureImage = imageToSave;
      returnObject.signatureImageFull = image;
      if ($scope.signatureCapture.nameRequired) {
        returnObject.signatureName = $scope.signatureCapture.name;
      }

      $scope.signatureCaptureCallback(returnObject);
      $("#signatureCaptureModal").fadeOut(100);
    }

    $scope.openTermsAttachments = function (attachments) {
      if ($scope.currentOrg && $scope.currentOrg.id) {
        for (var i = 0; i < attachments.length; i++) {
          window.open(DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/templates/' + $scope.signatureCapture.template.id + '/attachment/' + attachments[i].id);
        }
      } else {
        $scope.openDocketTermsAttachments();
      }
    }


  });



// WEBPACK FOOTER //
// ./src/controllers/modals/signatureModalController.js